// Vrais avis Google vérifiés — fiche Google Business "Azur Tech 06"
// Pour mettre à jour : remplacer/ajouter les avis ici (copiés depuis la fiche Google)
export const GOOGLE_REVIEWS_URL = "https://share.google/DUrON8BOcFKaDm6vA";

export const AVIS_GOOGLE = [
  {
    nom: "Atchama Patrice",
    ville: "Nice",
    note: 5,
    texte: "Rien à dire, intervention rapide et traitée efficacement pour des souris qui avaient élu domicile dans mes combles. Le technicien très sympathique a été rassurant.",
    date: "Février 2024",
    google: true
  },
  {
    nom: "Yoann Allard",
    ville: "Nice",
    note: 5,
    texte: "J'ai été impressionné par le service impeccable de cette société d'extermination des punaises de lit. Leur équipe compétente a rapidement résolu mon problème.",
    date: "Août 2023",
    google: true
  },
  {
    nom: "Ahmed Echihi",
    ville: "Nice",
    note: 5,
    texte: "Des professionnels compétents et sympathiques qui ont résolu mon problème de parasites. Je les recommande sans hésitation.",
    date: "Septembre 2023",
    google: true
  },
  {
    nom: "Hotmanie Nour",
    ville: "Nice",
    note: 5,
    texte: "Entreprise très professionnelle, le personnel également. Ils ont été très réactifs et se sont déplacés dans l'heure suivant mon appel.",
    date: "Août 2023",
    google: true
  },
  {
    nom: "Alexis Behanzin",
    ville: "Nice",
    note: 5,
    texte: "Je remercie la société Azur Tech pour sa réactivité et son efficacité. Aujourd'hui, mon problème de nuisibles est de l'histoire ancienne !",
    date: "Juillet 2023",
    google: true
  },
  {
    nom: "Karim Ouadah",
    ville: "Nice",
    note: 5,
    texte: "Très professionnel ! Il a compris très vite la situation et a su y remédier très rapidement.",
    date: "Juillet 2023",
    google: true
  },
  {
    nom: "Mehdi Bensalem",
    ville: "Nice",
    note: 5,
    texte: "Ayant eu des punaises de lit, je vous recommande cette société qui a été réactive et efficace pour m'en débarrasser ! Merci infiniment.",
    date: "Août 2023",
    google: true
  },
  {
    nom: "Yassine Guennaz",
    ville: "Nice",
    note: 5,
    texte: "J'ai eu recours aux services de cette société de désinsectisation et je suis extrêmement satisfait de leur professionnalisme.",
    date: "Août 2023",
    google: true
  },
  {
    nom: "Souhil Guennaz",
    ville: "Nice",
    note: 5,
    texte: "Excellent service et problème de blattes résolu en 1 passage.",
    date: "Janvier 2023",
    google: true
  },
  {
    nom: "Badis Doulache",
    ville: "Nice",
    note: 5,
    texte: "Travail professionnel et efficace pour un problème de punaises de lit.",
    date: "Août 2023",
    google: true
  },
  {
    nom: "Will Iam",
    ville: "Nice",
    note: 5,
    texte: "Super services, merci pour votre réactivité. Je recommande.",
    date: "Juin 2023",
    google: true
  },
  {
    nom: "David Cherubin",
    ville: "Nice",
    note: 5,
    texte: "Merci pour le service, je recommande.",
    date: "Août 2023",
    google: true
  },
  {
    nom: "Originel",
    ville: "Nice",
    note: 5,
    texte: "Rapide, efficace et à l'écoute. Je recommande, il saura répondre à vos besoins.",
    date: "Août 2023",
    google: true
  },
  {
    nom: "Elyesse Ben Salem",
    ville: "Nice",
    note: 5,
    texte: "Rapide et efficace, rien à dire.",
    date: "Août 2023",
    google: true
  },
  {
    nom: "AzurTech06",
    ville: "Nice",
    note: 5,
    texte: "Au top du top !!! Je recommande vivement.",
    date: "Août 2023",
    google: true
  },
  {
    nom: "Abdeslem Hattna",
    ville: "Nice",
    note: 5,
    texte: "Positif, service de qualité.",
    date: "Août 2023",
    google: true
  }
];
